import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const UserCardWrapper = styled.div`
  margin-left: 30px;
  margin-right: 30px;
  flex: 1 1 50%;
  max-width: 50%;
  @media (max-width: 1440px) {
    flex: 1 1 100%;
    max-width: 100%;
  }
`;

export const UserCard = styled.div`
  background: var(--bkg-secondary);
  border-radius: 8px;
  padding: 16px;
  width: 100%;
  flex-grow: 1;
  height: 100%;
`;

export const CardHeader = styled.div`
  padding-bottom: 8px;
  margin-bottom: 16px;
  h3 {
    margin: 0;
    font-size: 1.125rem;
    color: var(--main-color);
  }
  p {
    margin: 0;
    font-size: 0.875rem;
    color: var(--text-secondary);
  }
`;

export const UserList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const UserItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #444;
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
`;

export const UserName = styled.div`
  font-weight: medium;
  font-size: 1.125rem;
  color: #f0f1f5;
`;

export const UserEmail = styled.div`
  font-size: 0.875rem;
  color: #616168;
`;

export const UserStatus = styled.div`
  text-align: right;
  color: ${(props) => {
    switch (props.status) {
      case "pending":
        return "orange";
      case "active":
        return "green";
      case "banned":
        return "red";
      default:
        return "#ccc";
    }
  }};
`;

export const UserLocation = styled.div`
  font-size: 0.875rem;
  color: #ccc;
`;

export const ViewAllUsers = styled.div`
  text-align: center;
  margin-top: 16px;
  font-size: 1rem;
  color: var(--info);
  cursor: pointer;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 8px;
`;

export const StyledNavLink = styled(NavLink)`
  text-align: center;
  margin-top: 16px;
  font-size: 1rem;
  color: var(--info);
  cursor: pointer;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  gap: 8px;
  text-decoration: none;
`;
